import type { GooglePickerProps } from "@hightouch/formkit";
import type { SharedProps } from ".";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import useDrivePicker from "src/formkit/components/google-picker";
import { Box, Row, Select } from "@hightouch/htui";

export const FKGooglePicker = ({
  name,
  viewId,
  isDisabled,
}: GooglePickerProps & SharedProps) => {
  const [fileOptions, setFileOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const { control } = useFormContext();
  const [openPicker, _authResult] = useDrivePicker();
  const handleOpenPicker = (onChange) => {
    openPicker({
      appId: import.meta.env.VITE_GOOGLE_APP_ID?.toString() ?? "",
      clientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID?.toString() ?? "",
      developerKey: import.meta.env.VITE_GOOGLE_API_KEY?.toString() ?? "",
      viewId: viewId || "SPREADSHEETS",
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: false,
      callbackFunction: (data) => {
        if (data.action === "cancel") {
          return;
        }
        if (data?.docs?.[0]?.id) {
          setFileOptions([
            { label: data.docs[0].name, value: data.docs[0].id },
          ]);
          onChange({
            id: data.docs[0].id,
            name: data.docs[0].name,
            parent: data.docs[0].parentId,
          });
        }
      },
    });
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        if (
          field?.value?.id &&
          !fileOptions.some((opt) => opt.value === field.value.id)
        ) {
          setFileOptions([
            ...fileOptions,
            { label: field.value.name, value: field.value.id },
          ]);
        }
        return (
          <Box gap={2}>
            <Row>
              <Select
                isDisabled={isDisabled}
                placeholder="Click here to open the Google Drive picker…"
                options={fileOptions}
                value={field.value?.id ?? undefined}
                onChange={(_) => {
                  // Do nothing. change handled by google drive picker
                  return;
                }}
                onOpen={() => {
                  handleOpenPicker(field.onChange);
                }}
              />
            </Row>
          </Box>
        );
      }}
    />
  );
};
